module.exports = __webpack_public_path__ + "img/21.e48105bf.webp";